module.exports = require('./cjs/nivo-bar')
